import UIProps from './uiprops';

class Selection {

   constructor(selection) {
    
    this.positive_selection = {
        name: selection.positive_selection.selection_name,
        value: selection.positive_selection.selection_value,
        selected: selection.positive_selection.is_selected,
    };
    
    this.negative_selection = {
        name: selection.negative_selection.selection_name,
        value: selection.negative_selection.selection_value,
        selected: selection.positive_selection.is_selected,
    };
    
    this.ID = selection.ID;

   }


  /*
   * 
   */
   getVal() {
     if(this.positive_selection.selected === true || this.negative_selection.selected === true) {
         if(this.positive_selection.selected === true) {
           return 0;
         } else if (this.negative_selection.selected === true) {
           return 1;
         }
       } else {
          return null;
       }
   }



  /*
   * 
   */
   getSliderVal() {
     return this.getVal() !== null ? this.getVal : 0;
   }


  /*
   * 
   */
   selectSelection(val) {
       switch(val) {
          case 0:
            this.positive_selection.selected = true;
            this.negative_selection.selected = false;
            break;
          case 1:
            this.negative_selection.selected = true;
            this.positive_selection.selected = false;
            break;
       }
   }

}


class Element {

   
   constructor(element, feedback_content) {
     this.selections = [];
     this.totalPositives;
     this.totalNegatives;
     this.isComplete = false;
     this.ID = element.ID;
     this.post_title = element.post_title;
     this.title = element.title;
     this.excerpt = element.excerpt;
     this.subtitle = element.subtitle;
     this.setSelections(element.selections);
     this.updateElTotals();
     this.feedbackMessages = feedback_content.assure_can_help_with;
     this.assure_help = feedback_content;
     this.read_more_content = element.read_more_content;
     this.read_more_url = element.read_more_url;
   }

  /*
   * on initialisation will set Element's position selection
   */
   setSelections(selections) {
    for(var i = 0; i < selections.length; i++) {
      let selection = new Selection(selections[i]);
      this.selections.push(selection);
    }
   }


  /*
   * Updates a specified selection, updates Element's totals and checks if Element is completed 
   */
   updateSelection(index, val) {
    this.selections[index].selectSelection(val);
    this.updateElTotals();
    this.updateCompleteProp();
   }


  /*
   * Sets the count for Element instances total positives or negatives
   */
   numRes(val = 'positive') {
    var cnt = 0;
    this.selections.map( x => {
      switch(val){
        case 'positive':
          cnt += x.positive_selection.selected ? 1 : 0;
          break;
        case 'negative':
          cnt += x.negative_selection.selected ? 1 : 0; 
          break;
      }
    });
    return cnt;
   }


  /*
   * Updates totals for positive and negative of Element Instance 
   */
   updateElTotals() {
    this.totalPositives = this.numRes('positive');
    this.totalNegatives = this.numRes('negative');
   }


  /*
   * Updates the .isComplete property of Element instance 
   */
   updateCompleteProp(){
    this.isComplete =  this.totalPositives + this.totalNegatives === this.selections.length;
   }


  /*
   * Build array via loop of selections
   */
   mapSelections(action) {
      var map = [];
      this.selections.map(el => {
         action(el, map);
      });
      return map;
   }


  /*
   * Checks if whole element passes validation
   */
   passesValidation() {
    var passesValidation = true;
    this.selections.map(el => {
      if(el.positive_selection.selected === false && el.negative_selection.selected === false) {
         passesValidation = false;
      }
    });
    return passesValidation;
   }

  /*
   * Returns array of selections of specified type
   */
   listAllOfType(type = 'negative') {
     return this.mapSelections(function(el, map) {
        switch(type){
           case 'positive': 
              if(el.positive_selection.selected == true) {
                map.push(el);
              }
              break;
           case 'negative':
             if(el.negative_selection.selected == true) {
                map.push(el);
              }
              break;
        }
     });
   }


  /*
   * Returns count of selections
   */
   listCountOfType(type = 'negative') {
    return this.listAllOfType(type).length;
   }


  /*
   * Returns number of positive selections
   */
   getPositiveSelectionCount() {
    return this.listCountOfType('positive');
   }


  /*
   * Returns number of negative selections
   */
   getNegativeSelectionCount() {
    return this.listCountOfType('negative');
   }


  /*
   * Determines if score is perfect
   */
   isPerfectScore() {
    return this.getNegativeSelectionCount() == 0;
   }


  /*
   * Determines if score is positive
   */
   isPositiveScore() {
    return this.getNegativeSelectionCount() <= 1;
   }


  /*
   * determines if score is negative
   */
   isNegativeScore() {
     return this.getNegativeSelectionCount() >= 3;
   }


  /*
   * Determines the element's feedback depending on total score
   */
   generateFeedback() {

      var message, image;

      if(this.isPerfectScore()) {
        message = this.assure_help.positive.message_without_any_negatives;
        image = this.assure_help.positive.image; 
      } else if(this.isPositiveScore()) {
        message = this.assure_help.positive.message;
        image = this.assure_help.positive.image;
      } else if (this.isNegativeScore()) {
        message = this.assure_help.negative.message;
        image = this.assure_help.negative.image;  
      } else {
        message = this.assure_help.middle.message;
        image = this.assure_help.middle.image; 
      }

      return this.getFeedbackMessage(message, image);

   }


  /*
   * returns Elements feedback element
   */
   getFeedbackMessage(message, image) {
     return {
        message: message,
        image: image,
     };
    }



}


export default class Backbone {

  constructor(options) {
    this.uiProps;
    this.elements = [];
    this.currElement;
    this.ajaxUrl = options.ajaxUrl;
    this.ajaxNonce = options.ajaxNonce;
    this.feedbackElements = options.feedback_content;
    this.setElements(options.elements);
    this.bindClassPropsToUI();

    console.log(this.uiProps)
   }

  /*
   * Returns if whole Backbone is complete
   */
  isComplete() {
   var isComplete = true;
   this.elements.map(element => {
    if(element.isComplete === false) {
      isComplete = false;
    }
   });
   return isComplete;
  }


  /*
   * Loop thru elements and programatically map values to array
   */
  mapFromElements(action){
    var map = [];
    this.elements.map(element => {
      action(element, map);
    });
    return map;
  }


  /*
   * Returns Backbones completed elements
   */
  getCompletedElements() {
    return this.mapFromElements(function(element, elsArray) {
      if(element.isComplete) {
        elsArray.push(element);
      }
    });
  }


  /*
   * Returns Backbones incompleted elements
   */
  getIncompletedElements() {
    return this.mapFromElements(function(element, elsArray) {
      if(!element.isComplete) {
        elsArray.push(element);
      }
    });
  }


  getTotalElementCount(){
    return this.getElementCount();
  }


  /*
   * Gets count of elements 
   * type = all elements, completed elements, incomplete elements
   */
  getElementCount(type = 'all') {

    var count;

    switch(type){

      case 'all':
        count =  this.elements.length;
        break;

      case 'complete':
        count =  this.getCompletedElements().length;
        break;

      case 'incomplete': 
        count =  this.getIncompletedElements().length;
        break;

      default:
        count =  this.elements.length; 
        break;

    }

    return count;

  }

  
  /*
   * Returns Backbones completed elements count
   */
  getCompletedCount() {
   return this.getElementCount('complete');
  }


  /*
   * Returns Backbones incomplete elements count
   */
  getIncompleteCount() {
   return this.getElementCount('incomplete');
  }
    
  /*
   * On initialisation, sets Backbone's elements 
   */
  setElements(elements) {
   for(var i = 0; i < elements.length; i++) {
      let elementObj = new Element(elements[i], this.feedbackElements);
      this.elements.push(elementObj);
   }
   console.log(this.elements)
  }

  /*
   * Returns current element being viewed
   */
  getCurrentElement() {
    return this.currElement;
  }
  
  /*
   * Sets current element being viewed
   */
  setCurrentElement(currElement) {
    this.currElement = currElement;
  }


  bindClassPropsToUI(){
    var uiPropsClass = new UIProps(null, true);
    uiPropsClass.bindClassPropsToUI(this);
    var uiPropsObj = uiPropsClass.classProps;
    var uiPropsAlias = uiPropsClass.classPropsAlias;


    this.uiProps = new UIProps(uiPropsObj);
    console.log(uiPropsAlias);
  }  


}




// WEBPACK FOOTER //
// ./scripts/classes/backbone.js